function initSignUpSelect() {
  // Get the select element
  const selectElement = document.querySelector(".js-sign-up-select");

  // Get the <a> element
  const linkElement = document.querySelector(".js-sign-up-button");

  if (!selectElement || !linkElement) {
    return;
  }

  // Do this once on load so we have a href set
  const selectedValue = selectElement.value;
  // Set the href attribute with the selected value
  linkElement.href = selectedValue;

  // Add event listener to the select element
  selectElement.addEventListener("change", function () {
    // Get the selected value
    const selectedValue = selectElement.value;

    // Set the href attribute with the selected value
    linkElement.href = selectedValue;
  });
}

initSignUpSelect();
